import isString from 'lodash/isString'
import isObject from 'lodash/isObject'

/**
 * @param {object} map
 * @returns {boolean}
 */
const isObjectValuesAreString = map => {
  if (!isObject(map)) return false

  return Object.values(map).every(isString)
}

/**
 * @param {object} object
 * @returns {string}
 */
const stringifyStyles = object => {
  if (!isObject(object)) return ''

  Object.entries(object)
    .map(([prop, value]) => `${prop}: ${value}`)
    .join(';')
}

const commonStyles = {
  color: '#ddd',
  'border-radius': '3px'
}

export {
  isObjectValuesAreString,
  stringifyStyles,
  commonStyles
}



// WEBPACK FOOTER //
// ./src/utils/Logger/helpers.js